import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {isSortByPriceExperimentEnabled} from 'pages/search-transient-event-monthly/utils/sort-by-price-experiment';
import {setSortType as setSortTypeAction} from 'store/search/search-actions';

export default EnhancedComponent => {
    class WithSortByPriceExperiment extends Component {
        static propTypes = {
            setSortType: PropTypes.func.isRequired,
        };

        componentDidMount() {
            if (isSortByPriceExperimentEnabled()) {
                this.props.setSortType('price');
            }
        }

        render() {
            return <EnhancedComponent {...this.props} />;
        }
    }

    const mapDispatchToProps = {
        setSortType: setSortTypeAction,
    };
    const enhance = connect(null, mapDispatchToProps);

    return enhance(WithSortByPriceExperiment);
};
